import { render, staticRenderFns } from "./srcDownload.vue?vue&type=template&id=1c0a22c3&scoped=true"
import script from "./srcDownload.vue?vue&type=script&lang=js"
export * from "./srcDownload.vue?vue&type=script&lang=js"
import style0 from "./srcDownload.vue?vue&type=style&index=0&id=1c0a22c3&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c0a22c3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1c0a22c3')) {
      api.createRecord('1c0a22c3', component.options)
    } else {
      api.reload('1c0a22c3', component.options)
    }
    module.hot.accept("./srcDownload.vue?vue&type=template&id=1c0a22c3&scoped=true", function () {
      api.rerender('1c0a22c3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/applet/setting/companyapp/modules/srcDownload.vue"
export default component.exports